import React from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { Tabs } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';

const BalanceSheetTabs = withStyles((theme) => ({
  root: {},
  indicator: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    height: 5,
    '& > span': {
      width: '100%',
      backgroundColor: theme.palette.facet.accentBlue,
    },
  },
}))((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

export default BalanceSheetTabs;
